import { createClient } from '@supabase/supabase-js'
import config from '@/config/config.env'

const supabaseUrl = config.supabaseConfig.url
const supabaseAnonKey = config.supabaseConfig.anonKey

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided in environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})
